// Shared by the /tasks/trigger/<name>/ dev-tools buttons (MergedSurveyNotificationsCard,
// EmailSettingsCard, InstitutionalSettings). taskId/task_id casing is read defensively:
// the shared axios-case-converter middleware camelizes every response key at runtime, so
// task_id is dead in practice, but keeping both guards against a future non-`api`-client caller.
export const getTaskTriggerToastMessage = (data: { taskId?: string, task_id?: string, message?: string }): string => {
  const taskId = data.taskId ?? data.task_id
  return data.message ?? `Task queued — ID: ${taskId}`
}
